import ApiService from "@/services/api.service"

export const SendService = {
  sendSMS(params) {
    return ApiService.post(`sms`, params)
  },
  sendMail(params) {
    return ApiService.post(`mail`, params)
  },
  sendBulkMessage(params) {
    return ApiService.post(`message/bulk`, params)
  }
}
